import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ArchiveVolumeFile } from '../models/archive/archive-volume-file.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ArchiveVolumeFileService extends RequestService<ArchiveVolumeFile> {
  static PATH = '/archive/volume/file';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, ArchiveVolumeFileService.PATH, globalService.debugUrl);
  }

  moveUp(id: number) {
    return this.httpClient.get<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveVolumeFileService.PATH}/moveUp/${id}`
    );
  }

  moveDown(id: number) {
    return this.httpClient.get<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveVolumeFileService.PATH}/moveDown/${id}`
    );
  }
}
